import { Link } from "@/i18n/navigation";
import { Button, HStack, Text } from "@chakra-ui/react";
import { useTranslations } from "next-intl";
import { LuChevronRight } from "react-icons/lu";
import { IOption } from "../model/types";

type Props = {
  option: IOption;
};

const OptionItem: React.FC<Props> = ({ option }) => {
  const t = useTranslations("profile");
  return (
    <Link href={option.href}>
      <Button
        w="full"
        size="xl"
        variant="ghost"
        display="flex"
        justifyContent="space-between"
        borderBottom="1px solid"
        borderBottomColor="gray.100"
      >
        <HStack gap="4">
          {option.icon}
          <Text fontSize="md" color="gray.600">
            {t(option.title)}
          </Text>
        </HStack>
        <LuChevronRight size={32} />
      </Button>
    </Link>
  );
};

export default OptionItem;
